export default __webpack_public_path__ + "static/media/download.d99b226e.svg";